/**
 * Foto de perfil por defecto, para coaches y para alumnos (#37).
 *
 * Ruta ABSOLUTA a propósito: `defaultAvatar.png` estaba escrito sin la barra
 * inicial, así que se resolvía relativo a la pantalla y en producción devolvía
 * el index.html del SPA con un 200 engañoso.
 *
 * Y es un asset propio: los dos `onError` del código caían en una foto de stock
 * hotlinkeada desde ftcdn.net, un CDN ajeno que puede cortar el hotlinking
 * cuando se le antoje.
 */
export const DEFAULT_AVATAR = '/default-avatar.svg';
